module.exports = __webpack_public_path__ + "img/car-red.e53a1518.svg";